<script>
export default {
  name: "Questions",
  components: {},
  data: () => ({
    questions: [],
    // answers: [],
  }),
  computed: {
    step() {
      return this.$store.getters.step;
    },
    answers: {
      get() {
        return this.$store.getters.answers;
      },
      set(value) {
        this.$store.commit("SET_AWNSERS", value);
      },
    },
  },
  methods: {
    shuffle(array) {
      var currentIndex = array.length,
        temporaryValue,
        randomIndex;

      // While there remain elements to shuffle...
      while (0 !== currentIndex) {
        // Pick a remaining element...
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex -= 1;

        // And swap it with the current element.
        temporaryValue = array[currentIndex];
        array[currentIndex] = array[randomIndex];
        array[randomIndex] = temporaryValue;
      }

      return array;
    },
  },
  created() {
    // get questions actions store
    this.$store.dispatch("getQuestions").then(() => {
      this.questions = this.$store.getters.questions;

      // Colocar as respostas das questões em forma aleatória
      for (const question of this.questions) {
        question.options = this.shuffle(question.options);
      }
    });
  },
};
</script>
<template>
  <div id="Questions">
    <transition-group name="appear">
      <div
        class="question"
        :class="'question-' + (index + 1)"
        v-for="(question, index) in questions"
        :key="index"
        v-show="index + 1 == step"
      >
        <div
          class="question-header"
          :class="{ inverseQuestionHeader: step % 2 }"
        >
          <div class="question-text">
            <span v-html="question.question"></span>
          </div>
        </div>
        <div class="question-answers">
          <div
            class="question-answer"
            v-for="(answer, index) in question.options"
            :key="index"
          >
            <div class="question-answer-checkbox">
              <input
                type="radio"
                :name="'answer-' + question.id"
                :id="'answer-' + question.id + '-' + index"
                :value="answer.id"
                v-model="answers[step - 1].answer"
              />
            </div>
            <div class="question-answer-text">
              <span>
                <label :for="'answer-' + question.id + '-' + index">{{
                  answer.answer
                }}</label>
              </span>
            </div>
          </div>
        </div>
      </div>
    </transition-group>
  </div>
</template>
<style>
.appear-enter-active,
.appear-leave-active {
  transition: transform 1s, opacity 1s;
}

.appear-enter-from,
.appear-leave-to {
  opacity: 0;
  /* Realiza a transição lateral */
  position: absolute;
  transform: translateX(300px);
}

.appear-leave-from,
.appear-enter-to {
  opacity: 1;
  transform: translateX(0);
}
</style>
